const sizesMap = {
    xs: '15px',
    sm: '25px',
    md: '35px',
    lg: '50px',
}

export const defaultSize = 'md'

export const sizes = Object.keys(sizesMap)

export default sizesMap
